var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1175 9.2025C18.1175 8.61 18.065 8.0475 17.975 7.5H9.5V10.8825H14.3525C14.135 11.9925 13.4975 12.93 12.5525 13.5675V15.8175H15.4475C17.1425 14.25 18.1175 11.94 18.1175 9.2025Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4993 17.9998C11.9293 17.9998 13.9618 17.1898 15.4468 15.8173L12.5518 13.5673C11.7418 14.1073 10.7143 14.4373 9.4993 14.4373C7.1518 14.4373 5.1643 12.8548 4.4518 10.7173H1.4668V13.0348C2.9443 15.9748 5.9818 17.9998 9.4993 17.9998Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4525 10.7173C4.265 10.1773 4.1675 9.59984 4.1675 8.99984C4.1675 8.39984 4.2725 7.82234 4.4525 7.28234V4.96484H1.4675C0.852499 6.17984 0.5 7.54484 0.5 8.99984C0.5 10.4548 0.852499 11.8198 1.4675 13.0348L4.4525 10.7173Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4993 3.5625C10.8268 3.5625 12.0118 4.02 12.9493 4.9125L15.5143 2.3475C13.9618 0.892501 11.9293 0 9.4993 0C5.9818 0 2.9443 2.025 1.4668 4.965L4.4518 7.2825C5.1643 5.145 7.1518 3.5625 9.4993 3.5625Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.e5998fc246574d6c9dc779655541b1dc.svg";
export { ForwardRef as ReactComponent };